import { useQuery as i } from "react-query";
import { useBusinessModalContext as o } from "../BusinessModalContext.js";
const n = "cities", u = () => {
  const {
    apiClient: t
  } = o(), s = i([n, {}], () => t.business.getAllCities()), e = s.data?.cities;
  return [s, e];
};
export {
  n as CITIES,
  u as useCities
};
